export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VideoIcon.vue?vue&type=template&id=134affca"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/VideoIcon.vue?vue&type=template&id=134affca
// module id = 337
// module chunks = 0